import {Row,Col, Container, Image } from "react-bootstrap";
function Banner(){
    return(
        <>
        <Container  className="">
            <Row>
                <Col className="d-flex align-items-center">
                <p className="fw-bold m-0 discription">فريم لانسر هي وكالة إبداعية لتقنية تطبيقات الأجهزة المحمولة وتقنية الويب توفر حلولًا مبتكرة وعالية الجودة للشركات من جميع الأحجام. فريقنا من المصممين والمطورين والمسوقين الرقميين ذوي الخبرة لتقديم حلول مخصصة تلبي الاحتياجات الفريدة لكل عميل من عملائنا.</p>
                </Col>
                <Col className="d-flex align-items-center">
                <Image fluid className="bannerPhoto" src="./imgs/privacy.png" />
                </Col>
            </Row>

        </Container>
        <Container fluid>
        <Row className="flex-row-reverse">
                    <Col xs="2" className="p-0 d-flex justify-content-end">
                    <Image fluid className="bannerShape" src="./imgs/shape-2.png"/>
                    </Col>
                </Row>
        </Container>

        </>

        
    )
}

export default Banner;